import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import GradeLevelContainer from './grade-levels/container/GradeLevelContainer';

function StudentSettingsTabContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row border-bottom-row">
          <ul className="nav nav-tabs sub-tab-borongan">
            {/* {Acl(permissions, ['VIEW STUDENT PROGRAMS SETTINGS']) && (
              <li className="nav-item">
                <Link
                  to="/student/settings"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/student/settings/programs'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Programs
                </Link>
              </li>
            )} */}
            {Acl(permissions, ['VIEW STUDENT GRADE LEVEL SETTINGS']) && (
              <li className="nav-item">
                <Link
                  to="/social-ameliorations/settings/student/grade-levels"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/social-ameliorations/settings/student/grade-levels'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Grade Levels
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/grade-levels`} />}
        />
        {/* {Acl(permissions, ['VIEW STUDENT PROGRAMS SETTINGS']) && (
          <Route
            path={`${match.path}/programs`}
            component={GradeLevelContainer}
          />
        )} */}
        {Acl(permissions, ['VIEW STUDENT GRADE LEVEL SETTINGS']) && (
          <Route
            path={`${match.path}/grade-levels`}
            component={GradeLevelContainer}
          />
        )}
      </Switch>
    </React.Fragment>
  );
}

StudentSettingsTabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(StudentSettingsTabContainer);
